import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { createPatientTreatmentProtocol } from 'api/auth.api';

export const useSavePatientTreatmentProtocol = ({
  onSuccess,
  onError,
} = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: createPatientTreatmentProtocol,

    onSuccess: (res) => {
      toast({
        title: 'Patient Treatment Protocol',
        description:
          res?.data?.message || 'Treatment protocol saved successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      const data = error?.response?.data;

      // ✅ Special case: remark not submitted
      if (data?.isRemarkSubmitted === false) {
        toast({
          title: 'Remark Required',
          description: data?.message || 'Please submit remark first',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-center',
        });

        // 🔥 call callback AFTER toast
        onError?.(data);
        return;
      }

      // ❌ Normal error flow
      let errorMessage = 'Something went wrong';

      if (Array.isArray(data?.message)) {
        errorMessage = data.message.join(', ');
      } else if (typeof data?.message === 'string') {
        errorMessage = data.message;
      }

      toast({
        title: 'Failed to save treatment protocol',
        description: errorMessage,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
